import React, { useState, useEffect } from 'react';
import './Accounting.css';
import axios from 'axios';
import { useCart } from '../context/CartContext';
import { useSettings } from '../context/SettingsContext';

function ServicePlan({ id, title, price, features, type, onAddToCart, onRemoveFromCart, isInCart }) {
  const { currencySymbol } = useSettings();
  
  return (
    <div className={`plan-card ${type}`}>
      <h4>{title}</h4>
      <div className="price">{currencySymbol}{price}<span>/month</span></div>
      <ul>
        {features.map((feature, index) => (
          <li key={index}>{feature}</li>
        ))}
      </ul>
      {isInCart ? (
        <button 
          className="select-plan remove-btn"
          onClick={() => onRemoveFromCart(id)}
        >
          Remove from Cart
        </button>
      ) : (
        <button 
          className="select-plan"
          onClick={() => onAddToCart({ id, name: title, price })}
        >
          Add to Cart
        </button>
      )}
    </div>
  );
}

function Accounting() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { addToCart, removeFromCart, isInCart } = useCart();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/accounting/services`);
        
        // Add unique IDs to each service
        if (response.data && response.data.services) {
          // Add IDs to bookkeeping services
          if (response.data.services.bookkeeping) {
            response.data.services.bookkeeping.standard.id = 'accounting-bookkeeping-standard';
            response.data.services.bookkeeping.premium.id = 'accounting-bookkeeping-premium';
          }
          
          // Add IDs to GST services if they exist
          if (response.data.services.gst) {
            response.data.services.gst.standard.id = 'accounting-gst-standard';
            response.data.services.gst.premium.id = 'accounting-gst-premium';
          }
          
          // Add IDs to advisory services if they exist
          if (response.data.services.advisory) {
            response.data.services.advisory.standard.id = 'accounting-advisory-standard';
            response.data.services.advisory.premium.id = 'accounting-advisory-premium';
          }
        }
        
        setData(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleAddToCart = (item) => {
    addToCart(item);
  };

  const handleRemoveFromCart = (itemId) => {
    removeFromCart(itemId);
    // Optional: Show a confirmation message
    alert(`Item removed from cart!`);
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  if (!data) {
    return <div className="error">No data available</div>;
  }

  return (
    <div className="accounting-page">
      <section className="accounting-hero">
        <h1>{data.hero.title}</h1>
        <p className="hero-subtitle">{data.hero.subtitle}</p>
      </section>

      <section className="services-detail">
        <div className="service-container">
          <h2>Our Service Plans</h2>
          
          <div className="service-category">
            <h3>Bookkeeping Services</h3>
            <div className="plans-grid">
              <ServicePlan {...data.services.bookkeeping.standard} type="standard" onAddToCart={handleAddToCart} onRemoveFromCart={handleRemoveFromCart} isInCart={isInCart(data.services.bookkeeping.standard.id)} />
              <ServicePlan {...data.services.bookkeeping.premium} type="premium" onAddToCart={handleAddToCart} onRemoveFromCart={handleRemoveFromCart} isInCart={isInCart(data.services.bookkeeping.premium.id)} />
            </div>
          </div>
        </div>
      </section>

      <section className="why-choose-us">
        <h2>Why Choose Our Accounting Services?</h2>
        <div className="benefits-grid">
          {data.benefits.map((benefit, index) => (
            <div key={index} className="benefit-item">
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="contact-section">
        <h2>Ready to Streamline Your Accounting?</h2>
        <p>Contact us for expert accounting and bookkeeping services</p>
        <div className="contact-info">
          <p>Email: <a href={`mailto:${data.contact.email}`}>{data.contact.email}</a></p>
          <p>Phone: <a href={`tel:${data.contact.phone.replace(/\s+/g, '')}`}>{data.contact.phone}</a></p>
        </div>
      </section>
    </div>
  );
}

export default Accounting; 